import React, { useEffect, useState } from "react";
import bgElement from "../assets/bgElement.png";
import { client } from "../client";
import { coverImage } from "../utils/data";
import {
  Button,
  Expectation,
  Testimony,
  BriefFeed,
  AuthorFeed,
  BuyFeed,
  FooterFeed,
} from "../components";

const Home = () => {
  const [cover, setCover] = useState(null);
  // const [isModalOpen, setIsModalOpen] = useState(false);

  const spotlight = (e) => {
    document.documentElement.style.setProperty("--x", `${e.pageX}px`);
    document.documentElement.style.setProperty("--y", `${e.pageY}px`);
  };

  React.useEffect(() => {
    window.addEventListener("pointermove", spotlight);
    window.addEventListener("pointerdown", spotlight);

    return () => {
      window.removeEventListener("pointermove", spotlight);
      window.removeEventListener("pointerdown", spotlight);
    };
  }, []);

  useEffect(() => {
    const query = coverImage;

    client
      .fetch(query)
      .then((data) => {
        setCover(data[0]);
      })
      .catch((error) => {
        console.error("Error fetching cover image:", error);
      });
  }, []);

  return (
    <div className="w-full">
      <div className="w-full h-screen bg-[#EBEBE8] flex flex-col justify-center items-center">
        {/* cover bg */}
        <main className="z-10 pt-5 w-full flex flex-col justify-center items-center md:pt-20">
          {/* Register Button — top right of cover bg */}
          {/* <div className="absolute top-5 right-5 z-20 md:top-7 md:right-8">
            <button
              id="register-btn"
              onClick={() => setIsModalOpen(true)}
              className="px-5 py-2.5 rounded-full text-white text-sm font-semibold tracking-wide
                         transition-all duration-300 hover:scale-105 active:scale-95"
              style={{
                background:
                  "linear-gradient(135deg, #7c3aed 0%, #9f24f0 55%, #c026d3 100%)",
                boxShadow: "0 4px 20px rgba(124, 58, 237, 0.45)",
              }}
            >
              Attend The Book Launch &gt;
            </button>
          </div> */}

          {cover && (
            <img
              src={cover.image.asset.url}
              alt={cover.name}
              className="md:mt-10 w-56 h-92 shadow-black shadow-sm border-4 border-white rounded-lg md:w-80 md:h-100"
            />
          )}
          {/* Buy Buttons */}
          <div className="bg-[#D79807] bg-blend-darken overflow-y-hidden mt-12 w-[95%] mx-auto p-2 flex justify-center items-center rounded-lg shadow-black shadow-sm md:my-20 md:mb-28 md:w-4/5">
            <Button />
          </div>
        </main>
        <div className="absolute top-0 left-0 w-full h-full" id="bg">
          <div
            id="bg_pixelate"
            className="absolute bg-[#EBEBE8] top-0 left-0 w-full h-full object-cover pointer-events-none select-none"
            alt="Pixelated background"
          />
          <img
            src={bgElement}
            id="bg_focus"
            className="absolute top-0 left-0 w-full h-full object-cover pointer-events-none select-none"
            alt="Pixelated background"
            style={{
              maskImage:
                "radial-gradient(circle 50vmin at var(--x) var(--y), black var(--radius), transparent calc(var(--radius) + var(--blur)), transparent)",
            }}
          />
        </div>
      </div>

      {/* Registration Modal */}
      {/* <RegistrationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      /> */}

      {/* Expectations */}
      <div className="bg-[#EDF9FB] mt-0 w-full flex justify-center items-center mx-auto">
        <Expectation />
      </div>
      {/* Brief */}
      <div className="bg-gradient-to-b from-[#302118] to-[#6F3D25] p-5 mt-0 w-full flex justify-center items-center mx-auto border-4 border-white">
        <BriefFeed />
      </div>
      {/* Author */}
      <div className="bg-[#D79807] mt-0 w-full flex justify-center items-center mx-auto">
        <AuthorFeed />
      </div>
      {/* Content */}
      {/* <div className="bg-white mt-0 w-full flex justify-center items-center mx-auto">
        <ContentFeed />
      </div> */}
      {/* Testimonial */}
      <div className="bg-gradient-to-b from-[#302118] to-[#6F3D25] mt-0 w-full flex justify-center items-center mx-auto">
        <Testimony />
      </div>
      {/* Buy */}
      <div className="bg-white mt-0 w-full flex justify-center items-center mx-auto">
        <BuyFeed />
      </div>
      {/* Footer */}
      <div className="bg-gradient-to-b from-[#302118] to-[#6F3D25] p-5 mt-0 w-full flex justify-center items-center mx-auto">
        <FooterFeed />
      </div>
    </div>
  );
};

export default Home;
